import { Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import { PointExpirationBanner } from '@ocx/feat-point-expiration-schedule';

import { Typography, SizingMultiplier, Paper } from '@ocx/ui';

import { PointsStrategy } from '@ocx/graphql';
import { homeMessages } from '../../home.messages';
import { LoyaltyCurrencyBalance } from './loyalty-currency-balance.component';

export type WelcomeSectionProps = {
  points?: number;
  name?: string;
  loading: boolean;
  pointsStrategy: PointsStrategy;
  pointExpirationEnabled: boolean;
  handleClickToTransactionPage: () => void;
  handleClickToPointExpirationPage: () => void;
};

export const WelcomeSection = (props: WelcomeSectionProps) => {
  const {
    points,
    name,
    loading,
    pointsStrategy,
    pointExpirationEnabled,
    handleClickToTransactionPage,
    handleClickToPointExpirationPage,
  } = props;
  const intl = useIntl();

  return (
    <Stack component={Paper} direction="column" justifyContent="space-between" py={0} px={SizingMultiplier.md}>
      <Stack minHeight={64} justifyContent="space-between" gap={SizingMultiplier.md} direction="row">
        <Typography alignSelf="center">
          {name
            ? intl.formatMessage(homeMessages['home:pointsBox:customerGreetingWithName'], { customerName: name })
            : intl.formatMessage(homeMessages['home:pointsBox:customerGreeting'])}
        </Typography>

        {pointsStrategy !== PointsStrategy.NotUsed && points !== null && points !== undefined && (
          <LoyaltyCurrencyBalance
            points={points}
            pointsStrategy={pointsStrategy}
            loading={loading}
            onClick={handleClickToTransactionPage}
          />
        )}
      </Stack>

      {pointExpirationEnabled && (
        <PointExpirationBanner handleClickToPointExpirationPage={handleClickToPointExpirationPage} />
      )}
    </Stack>
  );
};
